import React from 'react';
import {
  PiPlusCircleLight,
  PiPencilSimpleLight,
  PiTrashLight,
  PiArchiveLight,
  PiArrowCounterClockwiseLight,
  PiCheckCircleLight,
  PiSparkleLight,
  PiUsersThreeLight,
  PiLinkLight,
  PiLinkBreakLight,
  PiShareNetworkLight,
  PiChatCircleTextLight,
  PiPaperclipLight,
  PiFileTextLight,
  PiClockCounterClockwiseLight,
} from 'react-icons/pi';
import { BadgeColor } from '../TailwindComponents/types/badgeTypes';
import { ActivityKind } from './activityModel';

/**
 * How an activity kind reads: its glyph and its badge colour.
 *
 * Fifteen entries, one per kind — not one per action. The audit panel used to
 * carry a Tailwind `text-*`/`bg-*` pair per action, which is how it ended up
 * with `text-teal-600`, `bg-sky-50`, `bg-slate-900/30` and friends sitting
 * outside the brand palette. Badge owns the colour ramps; this only picks
 * which one.
 */

const GLYPHS: Record<ActivityKind, React.ReactNode> = {
  created: <PiPlusCircleLight />,
  updated: <PiPencilSimpleLight />,
  deleted: <PiTrashLight />,
  archived: <PiArchiveLight />,
  restored: <PiArrowCounterClockwiseLight />,
  completed: <PiCheckCircleLight />,
  generated: <PiSparkleLight />,
  access: <PiUsersThreeLight />,
  link: <PiLinkLight />,
  unlink: <PiLinkBreakLight />,
  share: <PiShareNetworkLight />,
  comment: <PiChatCircleTextLight />,
  attachment: <PiPaperclipLight />,
  document: <PiFileTextLight />,
  other: <PiClockCounterClockwiseLight />,
};

const BADGE_COLORS: Record<ActivityKind, BadgeColor> = {
  created: 'green',
  updated: 'blue',
  deleted: 'red',
  archived: 'yellow',
  restored: 'green',
  completed: 'green',
  generated: 'purple',
  access: 'indigo',
  link: 'teal',
  unlink: 'yellow',
  share: 'cyan',
  comment: 'gray',
  attachment: 'sky',
  document: 'sky',
  other: 'gray',
};

export const activityGlyph = (kind: ActivityKind): React.ReactNode =>
  GLYPHS[kind] || GLYPHS.other;

export const activityBadgeColor = (kind: ActivityKind): BadgeColor =>
  BADGE_COLORS[kind] || 'gray';
